// src/services/statFormatUtils.js
// Shared stat formatting utilities — single source of truth for rate stat display

/**
 * Format batting rate stats (AVG, OBP, SLG, OPS, WHIP)
 * Rules: no leading zero, always 3 decimal places
 *   0.345 → .345
 *   0.35  → .350
 *   null  → —
 */
export const formatBattingAvg = (value) => {
  if (value == null || value === '') return '—';
  const num = Number(value);
  if (isNaN(num)) return '—';
  return num.toFixed(3).replace(/^0\./, '.');
};

/**
 * Format ERA (always 2 decimal places, keeps leading digits)
 *   3.45  → 3.45
 *   0.75  → 0.75
 *   null  → —
 */
export const formatERA = (value) => {
  if (value == null || value === '') return '—';
  const num = Number(value);
  if (isNaN(num)) return '—';
  return num.toFixed(2);
};
